<template>
    <div>
        <section class="material-half-bg">
            <div class="cover"></div>
        </section>
        <section class="login-content">
            <div class="logo">
                <img src="../assets/logo.png" alt="Cocall"/>
            </div>
            <div class="login-box">
                <form @submit="login" class="login-form">
                    <h3 class="login-head"><i class="fa fa-lg fa-fw fa-user"></i>{{$t('login')}}</h3>
                    <form-input :label="$t('email')" type="email" :model="form" attribute="email" :errors="errors" :placeholder="$t('emailPlaceholder')"></form-input>
                    <form-input :label="$t('password')" type="password" :model="form" attribute="password" :errors="errors" :placeholder="$t('passwordPlaceholder')"></form-input>
                    <div class="form-group btn-container">
                        <button @click="login" class="btn btn-primary btn-block">
                            <i class="fa fa-sign-in fa-lg fa-fw"></i>{{$t('login')}}
                        </button>
                    </div>
                  <p class="semibold-text mt-3"><router-link to="/forgot" data-toggle="flip">{{$t('forgot')}}</router-link></p>
                </form>
            </div>
            <lang></lang>
        </section>
    </div>
</template>

<script>
    import Lang from "../components/Lang";

    export default {
        components: {Lang},
        data: function () {
            return {
                form: {},
                errors: {},
            }
        },
        i18n: {
            messages: {
                en: {
                    login: 'Login',
                    email: 'Email:',
                    emailPlaceholder: 'Your account email',
                    password: 'Password:',
                    passwordPlaceholder: 'Your password',
                    remember: 'Remember me',
                    forgot: 'Forgot password?',
                },
                vi: {
                    login: 'Đăng nhập',
                    email: 'Email:',
                    emailPlaceholder: 'Email của bạn',
                    password: 'Mật khẩu:',
                    passwordPlaceholder: 'Mật khẩu của bạn',
                    remember: 'Tự động đăng nhập',
                    forgot: 'Quên mật khẩu?',
                }
            }
        },
        methods: {
            login: function (evt) {
                evt.preventDefault();
                let loader = this.$loading.show();
                this.errors = {};
                this.$service.post('/auth/login', this.form).then(response => {
                    return this.$store.dispatch('login', response.data);
                }).then(() => {
                    this.$router.push('/');
                }).catch(error => {
                    this.errors = error.response.data;
                }).finally(() => {
                    loader.hide();
                    const CALLIO_LIVECHAT_API = CALLIO_LIVECHAT_API || window.CALLIO_LIVECHAT_API || null;
                    if (CALLIO_LIVECHAT_API && this.$store.state.user) {
                      CALLIO_LIVECHAT_API.setAttributes({
                        'name': `${this.$store.state.user.name}`,
                        'email': `${this.$store.state.user.email}`,
                        'hash': `${this.$store.state.user._id}`,
                      });
                    }
                });
            },
        }
    };
</script>